$(document).ready(function() {

	// ## BRAND ##

	var tlBrand = new TimelineLite();
	var tlBrandFixed = new TimelineLite();
	var cube = ('svg#brand .cube');
	var societyLetter = ('svg#brand .ben-scholtes path');
	var baseline = ('svg#brand .baseline');

	tlBrand
		.from(cube, 1, {autoAlpha:0, ease: Power2.easeOut, delay: 2})
		.staggerFrom(societyLetter, 0.5, {ease: Power2.easeOut, autoAlpha:0, y: -25}, '0.1', '-= 0.5')
		.from(baseline, 0.5, {autoAlpha:0, ease: Power2.easeOut}, '-= 1.3');



	// ## 3 LOGOS TOP-MENU ##

	function brandingAnimate(brandName){

		var tl = new TimelineLite({paused:true, data:brandName});
		var brand = $(brandName);
		var figcaption = $(brand).find('figcaption');
		var figcaptionText = $(brand).find('figcaption p');

		tl
			.to(brand, 0.2, {autoAlpha:.9, ease:Power4.easeOut, delay:0.2})
			.to(brand, 0.2, {width:'150px', ease:Power4.easeOut, delay:0})
			.to(figcaption, 0.2, {width:'auto', height:'auto', autoAlpha:1, ease:Power4.easeOut, delay:0});

		$(document).on('mouseenter', brandName, function(){
	    tl.play();
		  
		}).on('mouseleave', brandName, function(){
	     tl.reverse().resume();
		});

	}
	
	var benscholtes = '.branding--benscholtes';
	var steelconcept = '.branding--steelconcept';
	var bsconstruction = '.branding--bsconstruction';
	var pick = '.branding--pick';
	
	brandingAnimate(benscholtes);
	brandingAnimate(steelconcept);
	brandingAnimate(bsconstruction);
	brandingAnimate(pick);


});